import React, { createContext, useCallback, useContext, useState } from 'react';
import { Dialog, DialogTitle, IconButton, Box } from '@mui/material';
import ReactDOM from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';

const DialogServiceContext = createContext();

export const useDialogService = () => useContext(DialogServiceContext);

export const DialogServiceProvider = ({ children }) => {
    const [dialog, setDialog] = useState(null);

    const open = useCallback((Component, props = {}) => {
        return new Promise((resolve) => {
            const handleClose = (result) => {
                resolve(result);
                setDialog(null);
            };

            setDialog({ Component, props, handleClose });
        });
    }, []);

    const DialogContainer = () => {
        if (!dialog) return null;
        const { Component, props, handleClose } = dialog;

        const handleDialogClose = (event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                handleClose(null);
            }
        };

        return (
            <Dialog open={true} onClose={handleDialogClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {props.header}
                        <IconButton
                            aria-label="close"
                            onClick={() => handleClose(null)}
                            size="small"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <Component {...props} onClose={handleClose} />
            </Dialog>
        );
    };

    return (
        <DialogServiceContext.Provider value={{ open }}>
            {children}
            {ReactDOM.createPortal(<DialogContainer />, document.body)}
        </DialogServiceContext.Provider>
    );
};